const isDateWithinRange = (dateInput: Date | null): boolean => {
    if (!dateInput) {
        return false;
    }

    const month = dateInput.getMonth() + 1;

    return month >= 4 && month <= 8;
};

export default isDateWithinRange;
